module.exports = __webpack_public_path__ + "static/piclife_about-26e1f02ebb339f52bba7f5e9854447a6.png";